import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { IdeaGenerator, IdeaCard } from "@/components/workspace/IdeasTab";
import { Sparkles } from "lucide-react";

export default function IdeasPage() {
  const [clients, setClients] = useState([]);
  const [clientId, setClientId] = useState("");
  const [ideas, setIdeas] = useState([]);

  useEffect(() => {
    api.get("/clients").then((r) => {
      setClients(r.data);
      if (r.data.length) setClientId(r.data[0].id);
    }).catch(() => {});
  }, []);

  const load = () => {
    if (clientId) api.get(`/clients/${clientId}/ideas`).then((r) => setIdeas(r.data)).catch(() => {});
  };
  useEffect(load, [clientId]);

  const client = clients.find((c) => c.id === clientId);

  return (
    <div className="space-y-5" data-testid="ideas-page">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex-1">
          <h1 className="font-heading text-3xl font-bold">Idées IA</h1>
          <p className="text-neutral-500 text-sm mt-1">L'IA s'appuie sur l'identité de marque de chaque client — jamais sur celle d'un autre.</p>
        </div>
        <Select value={clientId} onValueChange={setClientId}>
          <SelectTrigger data-testid="ideas-client-select" className="w-56"><SelectValue placeholder="Choisir un client" /></SelectTrigger>
          <SelectContent>{clients.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
        </Select>
        {clientId && <IdeaGenerator clientId={clientId} onGenerated={load} />}
      </div>
      {ideas.length === 0 ? (
        <div className="bg-white border border-neutral-200 rounded-xl shadow-sm p-12 text-center" data-testid="ideas-empty-global">
          <Sparkles className="w-8 h-8 mx-auto text-neutral-300 mb-3" />
          <p className="font-heading font-bold">Aucune idée générée pour ce client</p>
          <p className="text-sm text-neutral-500 mt-1">Cliquez sur « Générer des idées avec l'IA » pour démarrer.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {ideas.map((idea, i) => <IdeaCard key={idea.id} idea={idea} color={client?.color || "#999"} index={i} onRefresh={load} />)}
        </div>
      )}
    </div>
  );
}
